export {
  B2cDashboardModule,
  routeb2cdashboard,
  øB2cDashboardModule,
} from './b2c-dashboard.module';
export { StarterService } from './starter.service';
export { NoticeComponent } from './shared/notice/notice.component';
